import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import useGetCachedOrgInfo from './getCachedOrgInfo.hook';
import useGetConnectionParam from './getConnectionParam.hook';
import { setCachedOrgInfo } from '../store/actions/CountryStateOrgActions';
import useSetUrlParamsInStorage from './setUrlParamsInStorage';
import {
  setCachedOktaWidgetConfig,
  setLoginFlow,
  setLoginStep,
} from '../store/actions/TenantPickerActions';
import { setOktaConfig } from '../storageHelpers/sessionStorageAccessors';
import { useInteractionCodeParamHook } from './useInteractionCodeParam.hook';
import { LOGIN_FLOWS } from '../constants/constants';
import { useLoginHint } from './useLoginHint.hook';
import { handleAuthRedirect } from '../util/handleAuthRedirect';
import { handleLoginHint } from '../util/handleLoginHint';
import { handleOrgInfo } from '../util/handleOrgInfo';
import useCallbackParams from './useCallbackParams.hook';
import { redirectToInitialiseUri } from '../util/redirectToInitialiseUri';

function useBootstrapTenantPicker() {
  const dispatch = useDispatch();
  const orgPid = useGetConnectionParam();
  const { allKeysHaveValue, params } = useCallbackParams();
  const cachedOrgInfo = useGetCachedOrgInfo(orgPid);
  const { interactionCode, state } = useInteractionCodeParamHook();
  const loginHint = useLoginHint();
  useSetUrlParamsInStorage();

  useEffect(() => {
    if (interactionCode && state) {
      handleAuthRedirect(interactionCode, state);
      return;
    }

    if (loginHint && cachedOrgInfo) {
      handleLoginHint(dispatch, orgPid, cachedOrgInfo);
      return;
    }

    if (params && allKeysHaveValue) {
      setOktaConfig(JSON.stringify(params));
      dispatch(setLoginStep(2));
      dispatch(setLoginFlow(LOGIN_FLOWS.OKTA));
      dispatch(setCachedOktaWidgetConfig(params));
      dispatch(setCachedOrgInfo(cachedOrgInfo));
      return;
    }

    if (orgPid) {
      handleOrgInfo(dispatch, orgPid);
      return;
    }

    if (cachedOrgInfo) {
      dispatch(setCachedOrgInfo(cachedOrgInfo));
      dispatch(setLoginFlow(2));
      redirectToInitialiseUri(orgPid, cachedOrgInfo.data.org.orgRefId);
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);
}

export default useBootstrapTenantPicker;
